import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { PaperComponent, statusBar } from "../../utils";
import { useTranslation } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import "@ag-grid-community/core/dist/styles/ag-grid.css";
import "@ag-grid-community/core/dist/styles/ag-theme-alpine.css";
import { useDispatch, useSelector } from "react-redux";
import { updTagAct } from "../redux/project/projActions";
import StyledTooltip from "../shared/toolTip/StyledTooltip";
import { LuFilterX } from "react-icons/lu";

const LinkTag = (props) => {
  const { selectedRowsData, isLinkTagOpen, setIsLinkTagOpen, colDefs } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const commercialTypes = useSelector((state) => state.ctrl.commercialTypes);
  const allTags = useSelector((state) => state.project.tags);
  
  const [gridApi, setGridApi] = useState(null);

  const instrumentTags = allTags.filter(
    (tag) => !commercialTypes.includes(tag.technology_name)
  );

  const selectedLine = allTags.find(
    (tag) => tag.tag_id === selectedRowsData[0].tag_id
  );

  const handleCloseLinkTag = () => {
    setIsLinkTagOpen(false);
  };

  const colDefinitions = colDefs.map((column) => ({
    ...column,
    children: column.children.map((child) => ({
      ...child,
      editable: false,
    })),
  }));

  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    editable: false,
    sortingOrder: ["asc", "desc", " "],
    filterParams: {
      buttons: ["apply", "cancel"],
      closeOnApply: true,
    },
    menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
  };

  const onGridReady = (params) => {
    setGridApi(params?.api);

    if (selectedLine.gen_rel_tag === null) return;

    const tagIds = selectedLine.gen_rel_tag.split(",");
    params?.api.forEachNode((node) => {
      if (tagIds.includes(node.data.tag_id.toString())) {
        node.setSelected(true);
      }
    });
  };

  const handleOnClickLink = () => {
    const selectedRowsTagId = gridApi
      .getSelectedRows()
      .map((row) => row.tag_id.toString());
    // const selectedRowsTagId = gridApi
    //   .getRenderedNodes()
    //   .filter((node) => node.isSelected())
    //   .map((node) => node.data.tag_id.toString());

    const updTagPL = {
      ...selectedLine,
      gen_rel_tag: selectedRowsTagId.join(","),
    };

    dispatch(updTagAct(updTagPL));
    handleCloseLinkTag();
  };

  const clearFilters = () => {
    if (gridApi) {
      gridApi.setFilterModel(null);
    }
  };

  return (
    <Dialog
      open={isLinkTagOpen}
      fullWidth={true}
      maxWidth="lg"
      onClose={handleCloseLinkTag}
      className="muiForm-Modal"
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle className="model-title mb-0">
        <div className="header-row">
          <div id="draggable-dialog-title" className="header-row-title">
            Link Tag Window
          </div>
          <StyledTooltip
            title={"Clear Filters"}
            placement="bottom"
            disableInteractive
          >
            <label>
              <LuFilterX
                className="tag-grid-head-cntrl mx-2"
                onClick={clearFilters}
                style={{ cursor: "pointer" }}
              />
            </label>
          </StyledTooltip>
        </div>
      </DialogTitle>
      <DialogContent>
        <div
          style={{ height: "65vh" }}
          className="ag-theme-alpine marginRow muiForm mb-2 pt-3"
        >
          <AgGridReact
            defaultColDef={defaultColDef}
            columnDefs={colDefinitions}
            headerHeight={30}
            rowSelection={"multiple"}
            rowHeight={26}
            rowData={instrumentTags}
            onGridReady={onGridReady}
            statusBar={statusBar}
          />
        </div>
      </DialogContent>
      <DialogActions className="model-actions" style={{ paddingRight: "24px" }}>
        <button
          className="cnbtn btn cancel-btn"
          variant="outlined"
          onClick={handleCloseLinkTag}
        >
          {t("Cancel")}
        </button>

        <button
          className="sbtn btn success-btn"
          variant="contained"
          color="success"
          onClick={handleOnClickLink}
        >
          Link
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkTag;
